var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 366,
    height: 491,
    viewBox: "0 0 366 491",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.432 348.006L208.251 285.966L244.07 348.006H172.432Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.432 355.783L208.251 417.823L244.07 355.783H172.432Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.633 455.171L231.452 393.131L267.27 455.171H195.633Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.215 384.464L285.034 322.424L320.852 384.464H249.215Z",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249.215 392.242L285.034 454.282L320.852 392.242H249.215Z",
    stroke: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3102 364.95L109.129 302.91L144.948 364.95H73.3102Z",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3102 372.727L109.129 434.767L144.948 372.727H73.3102Z",
    stroke: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4782 432.726L58.2969 370.686L94.1157 432.726H22.4782Z",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.503 286.137L152.321 224.098L188.14 286.137H116.503Z",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.503 293.915L152.321 355.955L188.14 293.915H116.503Z",
    stroke: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.837 425.948L161.655 363.908L197.474 425.948H125.837Z",
    stroke: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M124.6 50.1118L102.318 9.74633L78.5016 49.2256L124.6 50.1118Z",
    stroke: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.496 55.5297L100.679 95.009L78.3972 54.6436L124.496 55.5297Z",
    stroke: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6298 18.2817L47.5925 3.72124L39.0014 17.962L55.6298 18.2817Z",
    stroke: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5779 20.9774L46.9869 35.2182L38.9495 20.6577L55.5779 20.9774Z",
    stroke: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1806 70.1011L11.9174 47.8851L-1.1906 69.6133L24.1806 70.1011Z",
    stroke: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1131 73.6046L11.0051 95.3328L-1.25807 73.1168L24.1131 73.6046Z",
    stroke: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1012 218.745L105.92 156.705L141.739 218.745H70.1012Z",
    stroke: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1012 226.523L105.92 288.562L141.739 226.523H70.1012Z",
    stroke: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M-21.4588 218.745L14.3599 156.705L50.1787 218.745H-21.4588Z",
    stroke: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M-21.4588 226.523L14.3599 288.562L50.1787 226.523H-21.4588Z",
    stroke: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1803 145.275L57.9991 83.2355L93.8178 145.275H22.1803Z",
    stroke: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1803 153.053L57.9991 215.093L93.8178 153.053H22.1803Z",
    stroke: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0148 292.214L62.8336 230.174L98.6523 292.214H27.0148Z",
    stroke: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0148 299.991L62.8336 362.031L98.6523 299.991H27.0148Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.90537e1846e1da64ec51eb38b1b917d7.svg";
export { ForwardRef as ReactComponent };